import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export interface AuditEntryRow {
  id: string
  source: string
  action_type: string
  target_type: string | null
  target_id: string | null
  actor_id: string | null
  actor_display_name: string | null
  details: Record<string, unknown> | null
  created_at: string
}

const PAGE_SIZE = 50

export interface AdminAuditEntriesParams {
  fromTs: string | null
  toTs: string | null
  actionType: string | null
  actorId: string | null
  page: number
}

export function useAdminAuditEntries(params: AdminAuditEntriesParams) {
  const { fromTs, toTs, actionType, actorId, page } = params
  const offset = (page - 1) * PAGE_SIZE

  return useQuery({
    queryKey: ['admin-audit-entries', fromTs ?? '', toTs ?? '', actionType ?? '', actorId ?? '', page],
    queryFn: async (): Promise<AuditEntryRow[]> => {
      const { data, error } = await supabase.rpc('get_admin_audit_entries', {
        p_from_ts: fromTs || null,
        p_to_ts: toTs || null,
        p_action_type: actionType || null,
        p_actor_id: actorId || null,
        p_limit: PAGE_SIZE,
        p_offset: offset,
      })
      if (error) throw error
      return (data ?? []) as AuditEntryRow[]
    },
    staleTime: 30_000,
  })
}

export { PAGE_SIZE as ADMIN_AUDIT_PAGE_SIZE }
